<script>
export default {
    props: {
        name: {
            required: true
        },
        selected: {
            default: false
        },
        overrideHref: {
            default: null,
            type: String,
            required: false
        }
    },

    data() {
        return {
            isActive: false
        };
    },

    computed: {
        href() {
            return '#' + (this.overrideHref || this.name.toLowerCase().replace(/ /g, '-'))
        }
    },

    mounted() {
        this.isActive = this.selected;
    }
}
</script>

<template>
    <div v-show="isActive" class="bg-white border border-top-0">
        <slot></slot>
    </div>
</template>